"use client";

import React, { useState, useEffect } from "react";
import ModalGalleryItem from "./ModalGalleryItem";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const Gallery = ({ title, images, popupImageSize, imagesInRow }) => {
  const [openGalleryImage, setOpenGalleryImage] = useState(false);
  const [defaultImage, setDefaultImage] = useState(false);
  const [defaultIndex, setDefaultIndex] = useState(false);

  useEffect(() => {
    const closeOnEscapePressed = (e) => {
      if (e.key === "Escape") {
        setOpenGalleryImage(false);
      }
    };
    window.addEventListener("keydown", closeOnEscapePressed);
    return () => window.removeEventListener("keydown", closeOnEscapePressed);
  }, []);

  const handleCarouselOpenGalleryImage = (e, index) => {
    e.preventDefault();
    setOpenGalleryImage(!openGalleryImage);
    setDefaultImage(images.data[index].attributes);
    setDefaultIndex(index);
  };

  const handleImageChange = (e, direction) => {
    e.preventDefault();
    if (direction === "next") {
      if (defaultIndex < images.data.length - 1) {
        setDefaultIndex(defaultIndex + 1);
        setDefaultImage(images.data[defaultIndex + 1].attributes);
      } else {
        setDefaultIndex(0);
        setDefaultImage(images.data[0].attributes);
      }
    } else {
      if (defaultIndex == 0) {
        setDefaultIndex(images.data.length - 1);
        setDefaultImage(images.data[images.data.length - 1].attributes);
      } else {
        setDefaultIndex(defaultIndex - 1);
        setDefaultImage(images.data[defaultIndex - 1].attributes);
      }
    }
  };

  return (
    <div className="tps-gallery-grid-wrapper">
      <div
        className={`tps-gallery-grid grid-x grid-margin-x small-up-1 medium-up-${
          imagesInRow > 1 ? 2 : 1
        } tablet-up-${
          imagesInRow >= 6
            ? imagesInRow - 3
            : imagesInRow >= 4
              ? imagesInRow - 2
              : imagesInRow >= 2
                ? imagesInRow - 1
                : 1
        } large-up-${imagesInRow}`}
      >
        {images.data.map((item, index) => {
          const imageAttributes = item?.attributes;
          return (
            <div className="tps-gallery-grid-item cell" key={index}>
              <a
                className="tps-gallery-grid-item-link tps-gallery-item"
                href="#"
                title={imageAttributes?.alternativeText}
                data-gallery-array-id={`galleryItems_${index}`}
                data-item-id={`${imageAttributes?.alternativeText?.replace(
                  / /,
                  ""
                )}-${index}`}
                data-item-image={getImageURL(imageAttributes.url)}
                data-item-description=""
                data-item-link=""
                data-item-index={index}
                data-class-name={`${popupImageSize} grid-item-modal`}
                onClick={() => {
                  handleCarouselOpenGalleryImage(event, index);
                }}
              >
                <Image
                  alt={imageAttributes?.alternativeText || ""}
                  src={getImageURL(
                    imageAttributes?.formats?.medium?.url || imageAttributes.url
                  )}
                  width={
                    imageAttributes?.formats?.medium?.width ||
                    imageAttributes.width
                  }
                  height={
                    imageAttributes?.formats?.medium?.height ||
                    imageAttributes.height
                  }
                />
              </a>
            </div>
          );
        })}
      </div>

      {openGalleryImage && (
        <ModalGalleryItem
          image={defaultImage}
          index={defaultIndex}
          display={openGalleryImage}
          handleImageChange={handleImageChange}
          onClose={() => setOpenGalleryImage(false)}
          popupImageSize={popupImageSize}
        />
      )}
    </div>
  );
};

export default Gallery;
